import {
  withTranslation,
} from 'react-i18next';

import ConfirmDialogView from './ConfirmDialogView';

const TranslatedComponent = withTranslation()(ConfirmDialogView);

const Component = TranslatedComponent;

export default Component;
